export default __webpack_public_path__ + "static/media/socialBgMb.22f59019.png";